// queries/useDeleteAccount.ts
"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch } from "libs";
import { DELETE_ACCOUNT } from "api";

export const useDeleteAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await fetch(DELETE_ACCOUNT, {
        // Make sure to use the correct endpoint URL
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response; // Assuming the server responds with JSON
    },
    onSuccess: () => {
      // Handle successful deletion, e.g., by redirecting to a login page or showing a success message
      console.log("Account deletion successful");
      queryClient.invalidateQueries({ queryKey: ["profile", "models"] }); // Adjust query keys as needed
    },
    onError: (error) => {
      // Handle any errors, e.g., by showing an error message
      console.error("Error in useDeleteAccount:", error);
    },
  });
};

export default useDeleteAccount;
